import Vue from 'vue'
import Vuex from 'vuex'

import authModule from './modules/auth'
import sheetsModule from './modules/sheets'
import languagesModule from './modules/languages'
import stepsModule from './modules/steps'
import answersModule from './modules/answers'
import categoriesModule from './modules/categories'
import sidebarModule from './modules/sidebar'

Vue.use(Vuex)

const state = {};

const getters = {};

const mutations = {};

const actions = {};

export default new Vuex.Store({
    modules: {
        auth: authModule,
        sheets: sheetsModule,
        languages: languagesModule,
        steps: stepsModule,
        answers: answersModule,
        categories: categoriesModule,
        sidebar: sidebarModule,
    },
    state,
    getters,
    mutations,
    actions
});